export const CURRICULUM_BASKET_TYPES = ['regular', 'focus', 'select'] as const

export type CurriculumBasketType = (typeof CURRICULUM_BASKET_TYPES)[number]
